import { Plugin } from "vue";
import { useUserStore } from "~stores/User.ts";

const plugin: Plugin = {
	install: (app, options) => {
		// inject a globally available $translate() method
		app.config.globalProperties.$isAllowed = (privilege) => {
			const { isAllowed } = useUserStore();

			return isAllowed(privilege);
		};

		app.config.globalProperties.$isReportCategoryAllowed = (category) => {
			const { isReportCategoryAllowed } = useUserStore();

			return isReportCategoryAllowed(category);
		};
	},
};

export default plugin;

declare module "vue" {
	interface ComponentCustomProperties {
		$isAllowed: (privilege: string) => boolean;
		$isReportCategoryAllowed: (category: string) => boolean;
	}
}
